import { API_URL } from '../../../request'

export const addUserUrl = () => {
  return API_URL + `/user`
}

export const updateUserUrl = (id) => {
  return API_URL + `/user/${id}`
}
